<!--
Document contains several places where events are implemented twice.
Duplication is necessary at the time of development to ensure support on all platforms.
Therefore repeated triggering of single events is accepted.
 e.g. pointermove & touchmove in #svgContainer
-->
<canvas #hiddenCanvas id='hiddenCanvas' style="display: none"></canvas>
<div class="itemAligner" data-tour="step6" style="position: relative">
  <ng-container *ngIf="userValidation$ && this.cardWeb">
    <em-recommendation-status-chip></em-recommendation-status-chip>
    <em-zoom-controls  [zoomLevel]="zoomLevel" (zoomChange)="onZoomChange($event)"></em-zoom-controls>
    <em-guest-view [guestList]="Array.from(this.guestList.values())"></em-guest-view>
    <em-status-display style="position: absolute; bottom: 0; pointer-events: none;"></em-status-display>
    <div id="editor"
         cdkDropList
         cdkDropListAutoScrollDisabled
         cdkDropListSortingDisabled
         cdkDropListConnectedTo="defaultDeck"
         (cdkDropListDropped)="dropNewCard($event)"
         [class.grabbing-cursor]="cardDrag">
      <div *cdkDragPlaceholder></div>

      <svg #svgContainer
           id="svgeditor"
           viewBox="10000,6000,800,800" height="90vh" width="100vw"
           (mousedown)="startDragGrid($event)"
           (pointermove)="doDragGrid($event)"
           (wheel)="zoom($event)"
           (pinch)="zoom($event)"
           (pointerdown)="startDragGrid($event); this.deselectAllCards(); this.deselectAllConnections();"
           (pointerup)="stopDragGrid($event);"
           (touchmove)="doDragGrid($event)">
        <defs>
          <svg id="plusSign">
            <circle [attr.cx]="20" [attr.cy]="20" r="17" fill="white" stroke="black" stroke-width="1"
                    stroke-opacity="0.8" fill-opacity="0.8"/>
            <line [attr.x1]="10" [attr.y1]="20" [attr.x2]="30" [attr.y2]="20" stroke="black" stroke-opacity="0.8"/>
            <line [attr.x1]="20" [attr.y1]="10" [attr.x2]="20" [attr.y2]="30" stroke="black" stroke-opacity="0.8"/>
          </svg>
          <pattern id="tenthGrid" width="10" height="10" patternUnits="userSpaceOnUse">
            <path d="M 10 0 L 0 0 0 10" fill="none" stroke="silver" stroke-width="0.5"/>
          </pattern>
          <pattern id="grid" width="100" height="100" patternUnits="userSpaceOnUse">
            <rect width="100" height="100" fill="url(#tenthGrid)"/>
            <path d="M 100 0 L 0 0 0 100" fill="none" stroke="gray" stroke-width="1"/>
          </pattern>
        </defs>
        <rect id="background" width="20000px" height="13000px" y="-1" x="-1" fill="url(#grid)" stroke="grey"/>
        <rect
          class="hoveredGrid"
          *ngIf="showHoverCard"
          [attr.x]="hoveredGridX"
          [attr.y]="hoveredGridY"
          width="208pt"
          height="312pt"
          rx="15"
          fill-opacity="0.2"
          fill="#009ccd"
        ></rect>
        <ng-container *ngIf="this.gameDesign">
          <ng-container
            *ngIf="isConnectionSelected && (gameDesign.gameDesignRelations.length || gameDesign.gameDesignProblemRelations.length)">

            <ng-container *ngIf="this.calculateRelationCoordinates(selectedConnection.sourceId, selectedConnection.targetId).pos==='left' ||
            this.calculateRelationCoordinates(selectedConnection.sourceId, selectedConnection.targetId).pos==='right'">
              <ng-container *ngIf="this.canSelectedConnectionHaveNote()">
                <a matTooltip="Verbindung entfernen" [matTooltipShowDelay]="800">
                  <svg class="deleteSymbol" width="22" height="22" viewBox="-2 -2 24 24"
                       (pointerdown)="removeConnection(); $event.stopImmediatePropagation();"
                       [@fadeInOut] style="cursor: pointer"
                       [attr.x]="this.calculateRelationDeleteCoordinates().x"
                       [attr.y]="this.calculateRelationDeleteCoordinates().y">
                    <rect width="22" height="22" fill-opacity="0"/>
                    <line x1="1" y1="2" x2="18" y2="18" stroke="#e62727" stroke-width="5"/>
                    <line x1="1" y1="18" x2="18" y2="2" stroke="#e62727" stroke-width="5"/>
                  </svg>
                </a>
              </ng-container>
              <ng-container *ngIf="this.canSelectedConnectionHaveNote()">
                <a (pointerdown)="openRelationNoteMenuForSelectedConnection($event)" matTooltip="Verbindung beschriften" [matTooltipShowDelay]="800">
                  <svg xmlns="http://www.w3.org/2000/svg"
                       [attr.x]="this.calculateRelationNoteMenuCoordinates().x"
                       [attr.y]="this.calculateRelationNoteMenuCoordinates().y"
                       style="cursor: pointer" height="40px" width="40px" viewBox="0 -960 960 960" fill="#545454">
                    <rect class="note_rect" rx="100" y="-960" height="960px" width="960px" fill="#4b4b4b" [@fadeInOut]
                          stroke-opacity="1" fill-opacity="0.9"/>
                    <path class="no_pointer_events" xmlns="http://www.w3.org/2000/svg" d="M200-200h360v-200h200v-360H200v560Zm0 80q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v400L600-120H200Zm80-280v-80h200v80H280Zm0-160v-80h400v80H280Zm-80 360v-560 560Z" fill="white"/>
                  </svg>
                </a>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="this.calculateRelationCoordinates(selectedConnection.sourceId, selectedConnection.targetId).pos==='bottom'">
              <ng-container *ngIf="this.canSelectedConnectionHaveNote()">
                <a matTooltip="Verbindung entfernen" [matTooltipShowDelay]="800">
                  <svg class="deleteSymbol" width="22" height="22" viewBox="-2 -2 24 24"
                       (pointerdown)="removeConnection(); $event.stopImmediatePropagation()"
                       [attr.x]="this.calculateRelationDeleteCoordinates('bottom').x"
                       [@fadeInOut] style="cursor: pointer"
                       [attr.y]="this.calculateRelationDeleteCoordinates('bottom').y">
                    <rect width="22" height="22" fill-opacity="0"/>
                    <line x1="1" y1="2" x2="18" y2="18" stroke="#e62727" stroke-width="5"/>
                    <line x1="1" y1="18" x2="18" y2="2" stroke="#e62727" stroke-width="5"/>
                  </svg>
                </a>
              </ng-container>
              <ng-container *ngIf="this.canSelectedConnectionHaveNote()">
                <a (pointerdown)="openRelationNoteMenuForSelectedConnection($event)" matTooltip="Verbindung beschriften" [matTooltipShowDelay]="800">
                  <svg xmlns="http://www.w3.org/2000/svg"
                       [attr.x]="this.calculateRelationNoteMenuCoordinates('bottom').x"
                       [attr.y]="this.calculateRelationNoteMenuCoordinates('bottom').y"
                       style="cursor: pointer" height="40px" width="40px" viewBox="0 -960 960 960" fill="#545454">
                    <rect class="note_rect" rx="100" y="-960" height="960px" width="960px" fill="#4b4b4b" [@fadeInOut]
                          stroke-opacity="1" fill-opacity="0.9"/>
                    <path class="no_pointer_events" xmlns="http://www.w3.org/2000/svg" d="M200-200h360v-200h200v-360H200v560Zm0 80q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v400L600-120H200Zm80-280v-80h200v80H280Zm0-160v-80h400v80H280Zm-80 360v-560 560Z" fill="white"/>
                  </svg>
                </a>
              </ng-container>
            </ng-container>
          </ng-container>

          <!-- currently Decktype is not working in selectConnection(), therefore a string is passed -->
          <ng-container *ngFor="let relation of this.getDesignRelations()">
            <rect *ngIf="this.calculateRelationCoordinates(relation.sourceCardId, relation.targetCardId).pos==='left' ||
                this.calculateRelationCoordinates(relation.sourceCardId, relation.targetCardId).pos==='right'"
                  [ngClass]="{'selectedConnection': selectedConnection.sourceId === relation.sourceCardId && selectedConnection.targetId === relation.targetCardId && isConnectionSelected, 'lockStyles': this.hasLinkLock(relation.gameDesignRelation.sourceId, relation.gameDesignRelation.targetId)}"
                  style="height: 38px; width: 141px; fill: #D9AB82"
                  [attr.x]="this.calculateRelationCoordinates(relation.sourceCardId, relation.targetCardId).x"
                  [attr.y]="this.calculateRelationCoordinates(relation.sourceCardId, relation.targetCardId).y"
                  [attr.sourceId]="relation.sourceCardId"
                  [attr.targetId]="relation.targetCardId"
                  (pointerdown)="relation.isLinkageConnection ? this.selectLinkageConnection(
                    $event,
                    relation.sourceCardId,
                    relation.targetCardId,
                    relation.gameDesignRelation,
                    relation.deckType
                    ) : this.selectConnection(
                    relation.gameDesignRelation.sourceId,
                    relation.gameDesignRelation.targetId,
                    relation.gameDesignRelation.relationItemId,
                    relation.deckType); $event.stopImmediatePropagation()">
            </rect>
            <rect *ngIf="this.calculateRelationCoordinates(relation.sourceCardId, relation.targetCardId).pos==='bottom'"
                  [ngClass]="{'selectedConnection': selectedConnection.sourceId === relation.sourceCardId && selectedConnection.targetId === relation.targetCardId && isConnectionSelected, 'lockStyles': this.hasLinkLock(relation.gameDesignRelation.sourceId, relation.gameDesignRelation.targetId)}"
                  style="height: 94px; width: 45px; fill: #D9AB82"
                  [attr.x]="this.calculateRelationCoordinates(relation.sourceCardId, relation.targetCardId).x"
                  [attr.y]="this.calculateRelationCoordinates(relation.sourceCardId, relation.targetCardId).y"
                  [attr.sourceId]="relation.sourceCardId"
                  [attr.targetId]="relation.targetCardId"
                  (pointerdown)="relation.isLinkageConnection ? this.selectLinkageConnection(
                    $event,
                    relation.sourceCardId,
                    relation.targetCardId,
                    relation.gameDesignRelation,
                    relation.deckType
                    ) : this.selectConnection(
                    relation.gameDesignRelation.sourceId,
                    relation.gameDesignRelation.targetId,
                    relation.gameDesignRelation.relationItemId,
                    relation.deckType); $event.stopImmediatePropagation()">
            </rect>
            <foreignObject #foreignObjectAvatar
                           *ngIf="!this.hasRelationNote(relation.gameDesignRelation.sourceId, relation.gameDesignRelation.targetId) && this.hasLinkLock(relation.gameDesignRelation.sourceId, relation.gameDesignRelation.targetId)"
                           [attr.x]="relation.cordX" class="avatar-icon-container"
                           [attr.y]="relation.cordY - 5" width="120pt" height="60pt">
              <ng-container *ngIf="this.getLinkLock(relation.gameDesignRelation.sourceId, relation.gameDesignRelation.targetId) as linkLock">
                <img matTooltip="{{linkLock.communityMember.username}}" class="avatar-icon-lock" src="{{this.getAvatarTemplateUrl(linkLock.communityMember.avatarTemplate)}}" alt="avatarImage">
              </ng-container>
            </foreignObject>
          </ng-container>
          <ng-container *ngFor="let relation of this.getLinkageCardRelations()">
            <rect *ngIf="this.calculateRelationCoordinates(relation.sourceId, relation.targetId).pos==='left' ||
                this.calculateRelationCoordinates(relation.sourceId, relation.targetId).pos==='right'"
                  [ngClass]="{'selectedConnection': selectedConnection.sourceId === relation.sourceId && selectedConnection.targetId === relation.targetId && isConnectionSelected}"
                  style="height: 38px; width: 141px; fill: #D9AB82"
                  [attr.x]="this.calculateRelationCoordinates(relation.sourceId, relation.targetId).x"
                  [attr.y]="this.calculateRelationCoordinates(relation.sourceId, relation.targetId).y"
                  (pointerdown)="selectLinkageConnection($event, relation.sourceId, relation.targetId, relation, relation.deckType); $event.stopImmediatePropagation()">
            </rect>
            <rect *ngIf="this.calculateRelationCoordinates(relation.sourceId, relation.targetId).pos==='bottom'"
                  [ngClass]="{'selectedConnection': selectedConnection.sourceId === relation.sourceId && selectedConnection.targetId === relation.targetId && isConnectionSelected}"
                  style="height: 94px; width: 45px; fill: #D9AB82"
                  [attr.x]="this.calculateRelationCoordinates(relation.sourceId, relation.targetId).x"
                  [attr.y]="this.calculateRelationCoordinates(relation.sourceId, relation.targetId).y"
                  (pointerdown)="selectLinkageConnection($event, relation.sourceId, relation.targetId, relation, relation.deckType); $event.stopImmediatePropagation()">
            </rect>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="cardWeb">
          <ng-container *ngFor="let cw of cardWeb.cards">
            <foreignObject #foreignObj
                           class="editorElement"
                           (click)="$event.stopImmediatePropagation()"
                           (pointerdown)="startDragElement($event, foreignObj, cw); selectCard(foreignObj, cw);"
                           (touchstart)="startDragElement($event, foreignObj, cw); selectCard(foreignObj, cw);"
                           [attr.id]="cw.id"
                           [attr.x]="this.calculateCardXCoordinates(cw.posX)"
                           [attr.y]="this.calculateCardYCoordinates(cw.posY, cw.posX)" height="314pt" width="208pt">
              <ng-container *ngIf="cw.cardDeckType === DeckType.linkage">
                <em-linkage-card [rightSidenav]="rightSidenav"
                                 [linkageCardWebElement]="cw"
                                 [elementLock]="this.getLinkageCardElementLock(cw)"
                                 [ngClass]="{'selected': selectedCardId === cw.id}">
                </em-linkage-card>
              </ng-container>
              <ng-container *ngIf="cw.cardDeckType !== DeckType.linkage">
                <em-pattern-card [rightSidenav]="rightSidenav"
                                 [cardPatternId]="cw.id"
                                 [cardDeckId]="cw.cardDeckId"
                                 [cardDeckType]="cw.cardDeckType"
                                 [elementLock]="this.lockCardMap.get(cw.id)"
                                 [showSelectToggle]="false"
                                 [shareOption]="this.shareOption"
                                 [ngClass]="{'selected': selectedCardId === cw.id}">
                </em-pattern-card>
                <ng-container *ngIf="hasCardNote(cw.id)">
                  <em-note-sticky
                    [text]="this.getCardNoteText(cw.id)"
                    [elementLock]="this.lockCardMap.get(cw.id)"
                    [width]="185"
                    [maxCollapsedHeight]="135"
                    [maintainMinimumHeight]="true"
                    [left]="2.35"
                    [noteType]="this.getCardNoteType(cw.id)"
                    [maxExpandedHeight]="230"
                    (pointerenter)="$event.stopImmediatePropagation()"
                    style="position:absolute; bottom: 1rem"
                  >
                  </em-note-sticky>
                </ng-container>
              </ng-container>
            </foreignObject>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="this.gameDesign">
          <ng-container *ngFor="let relation of getAllNoteRelations()">
            <ng-container *ngIf="hasRelationNote(relation.sourceId, relation.targetId)">
              <foreignObject #foreignObj2 class="relation-note-container"
                             (click)="$event.stopImmediatePropagation()"
                             [attr.x]="relation.cordX"
                             [attr.y]="relation.cordY"  width="185" height="90" >
                <em-note-sticky
                  [text]="this.getRelationNoteText(relation.sourceId, relation.targetId)"
                  [width]="170"
                  [maxCollapsedHeight]="90"
                  [maintainMinimumHeight]="true"
                  [elementLock]="this.getLinkLock(relation.sourceId, relation.targetId)"
                  [left]="0"
                  [noteType]="getRelationNoteType(relation.sourceId, relation.targetId)"
                  [maxExpandedHeight]="200"
                  [attr.x]="relation.cordX"
                  [attr.y]="relation.cordY"
                  style="bottom: 0">
                </em-note-sticky>
              </foreignObject>
              <!-- separate transparent rect is necessary because click event handling in foreign object not possible -->
              <rect [attr.x]="relation.cordX"
                    [attr.y]="relation.cordY" width="185" height="90" style="fill: transparent"
                    (pointerdown)="relation.isLinkageConnection ? this.selectLinkageConnection(
                    $event,
                    relation.neighbourSourceId,
                    relation.neighbourTargetId,
                    relation,
                    relation.deckType
                    ) : this.selectConnection(
                    relation.sourceId,
                    relation.targetId,
                    relation.relationItemId,
                    relation.deckType);  $event.stopImmediatePropagation()"/>
              <foreignObject #foreignObjectAvatar *ngIf="this.hasLinkLock(relation.sourceId, relation.targetId)"
                             [attr.x]="relation.cordX" class="avatar-icon-container"
                             [attr.y]="relation.cordY" width="120pt" height="60pt" >
                <ng-container *ngIf="this.getLinkLock(relation.sourceId, relation.targetId) as linkLock">
                  <img matTooltip="{{linkLock.communityMember.username}}" class="avatar-icon-lock" src="{{this.getAvatarTemplateUrl(linkLock.communityMember.avatarTemplate)}}" alt="avatarImage">
                </ng-container>
              </foreignObject>
            </ng-container>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="isCardSelected && cardWeb.cards.length">
          <!--explicitly is false when cards[] is empty to remove all artifacts when editor is reset-->
          <a (pointerdown)="removeCard()" matTooltip="Karte entfernen" [matTooltipShowDelay]="800">
            <svg class="deleteSymbol" width="22" height="22" viewBox="-2 -2 24 24" [attr.x]="plusSignX + 270"
                 [@fadeInOut] style="cursor: pointer"
                 [attr.y]="plusSignY - 10">
              <rect width="22" height="22" fill-opacity="0"/>
              <line x1="1" y1="2" x2="18" y2="18" stroke="#e62727" stroke-width="5"/>
              <line x1="1" y1="18" x2="18" y2="2" stroke="#e62727" stroke-width="5"/>
            </svg>
          </a>

          <a *ngIf="canConnectLeft()"  matTooltip="Verbindung hinzufügen" [matTooltipShowDelay]="1400">
            <svg #svgPlusSignLeft class="plus-sign-left button-effect" [attr.x]="plusSignX - 35 - mouseMoveDragLeft" [attr.y]="plusSignY + 330"
                 (pointerdown)="startPlusSignDrag($event,'left');"
                 (pointerdown)="startPlusSignDrag($event,'left');"
                 style="cursor: pointer"
                 [@fadeInOut]>
              <circle [attr.cx]="20" [attr.cy]="20" r="18" fill="#4b4b4b" stroke="#4b4b4b" stroke-width="1" [@fadeInOut]
                      stroke-opacity="1" fill-opacity="0.9"/>
              <line [attr.x1]="8" [attr.y1]="20" [attr.x2]="32" [attr.y2]="20" stroke="white" stroke-width="4"
                    stroke-opacity="1"/>
              <line [attr.x1]="20" [attr.y1]="8" [attr.x2]="20" [attr.y2]="32" stroke="white" stroke-width="4"
                    stroke-opacity="1"/>
            </svg>
          </a>

          <a *ngIf="canConnectRight()" matTooltip="Verbindung hinzufügen" [matTooltipShowDelay]="1400">
            <svg #svgPlusSignRight class="plus-sign-right button-effect" [attr.x]="plusSignX + 240 + 35 - mouseMoveDragRight" [attr.y]="plusSignY + 330" [@fadeInOut]
                 (pointerdown)="startPlusSignDrag($event,'right');"
                 style="cursor: pointer">
              <circle [attr.cx]="20" [attr.cy]="20" r="18" fill="#4b4b4b" stroke="#4b4b4b" stroke-width="1" [@fadeInOut]
                      stroke-opacity="1" fill-opacity="0.9"/>
              <line [attr.x1]="8" [attr.y1]="20" [attr.x2]="32" [attr.y2]="20" stroke="white" stroke-width="4"
                    stroke-opacity="1"/>
              <line [attr.x1]="20" [attr.y1]="8" [attr.x2]="20" [attr.y2]="32" stroke="white" stroke-width="4"
                    stroke-opacity="1"/>
            </svg>
          </a>

          <a *ngIf="canConnectBottom()" matTooltip="Verbindung hinzufügen" [matTooltipShowDelay]="1400">
            <svg #svgPlusSignBottom class="plus-sign-bottom button-effect" [attr.x]="plusSignX + 120" [attr.y]="plusSignY + 380 + 40 - mouseMoveDragBottom"
                 (pointerdown)="startPlusSignDrag($event,'bottom');"
                 style="cursor: pointer">
              <circle [attr.cx]="20" [attr.cy]="20" r="18" fill="#4b4b4b" stroke="#4b4b4b" stroke-width="1" [@fadeInOut]
                      stroke-opacity="1" fill-opacity="0.9"/>
              <line [attr.x1]="8" [attr.y1]="20" [attr.x2]="32" [attr.y2]="20" stroke="white" stroke-width="4"
                    stroke-opacity="1"/>selectedConnection
              <line [attr.x1]="20" [attr.y1]="8" [attr.x2]="20" [attr.y2]="32" stroke="white" stroke-width="4"
                    stroke-opacity="1"/>
            </svg>
          </a>

          <a *ngIf="canHaveNote()" (pointerdown)="openCardNodeMenu($event)" matTooltip="Karte beschriften" [matTooltipShowDelay]="800">
            <svg xmlns="http://www.w3.org/2000/svg" [attr.x]="plusSignX + 277" [attr.y]="plusSignY + 240"
                 style="cursor: pointer" height="40px" width="40px" viewBox="0 -960 960 960" fill="#545454">
              <rect class="note_rect" rx="100" y="-960" height="960px" width="960px" fill="#4b4b4b" [@fadeInOut]
                    stroke-opacity="1" fill-opacity="0.9"/>
              <path class="no_pointer_events" xmlns="http://www.w3.org/2000/svg" d="M200-200h360v-200h200v-360H200v560Zm0 80q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v400L600-120H200Zm80-280v-80h200v80H280Zm0-160v-80h400v80H280Zm-80 360v-560 560Z" fill="white"/>
            </svg>
          </a>
        </ng-container>
      </svg>

    </div>
  </ng-container>

</div>

